export const projectColors = {
  backGrey: '#D9D9D9',
  textBlue: '#35A9EA',
  scoreRed: '#E72D04',
  scoreOrange: '#E78C04',
  scoreGreen: '#5FB10D',
  purple: '#9138D3',
  barGreen: '#26D037',
  flashyGreen: '#38D363',
  wrongRed: '#CF0808',
  nameOrange: '#FFBF1A',
  géographie: '#06D6A0',
  histoire: '#EF476F',
  mathématiques: '#FFC43D',
  sciences: '#fa9862',
  anglais: '#1B9AAA',
  espagnol: '#5438DC',
  lightGrey: '#BDBDBD',
  darkGrey: '#37474F',
  whiteish: '#F9F8F4',
  backGround: '#F9F8F4',
};

export const commonButton = {
  background: projectColors.lightBlue,
  color: 'white',
  fontWeight: '700',
  border: '1px solid white',
  borderRadius: '50px',
  //   boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
  '&:hover': {
    bgcolor: projectColors.orange,
  },
  fontSize: '12px',
};

export const commonH = {
  color: projectColors.darkBlue,
  // fontFamily: 'Inter',
  fontStyle: 'normal',
};

export const headlinePaper = {
  borderRadius: '16px',
  border: `1px solid ${projectColors.textBlue}`,
  background: 'rgba(217, 217, 217, 0.16)',
};

export const scoreHeadlinePaper = {
  borderRadius: '16px',
  border: '1px solid #9138D3',
  background: 'rgba(217, 217, 217, 0.16)',
  boxShadow: 'none',
};

export const actionPaper = {
  borderRadius: '16px',
  border: '2px solid var(--colors-2-color-24, #35A9EA)',
  background: 'rgba(53, 169, 234, 0.08)',
};

const commonActionButton = {
  border: '2px solid',
  borderRadius: '16px',
  fontWeight: '700',
  fontSize: '16px',
};

export const blueActionButton = {
  ...commonActionButton,
  color: projectColors.textBlue,
  background: 'rgba(53, 169, 234, 0.08)',
};

export const purpleActionButton = {
  ...commonActionButton,
  color: projectColors.purple,
};

export const darkActionButton = {
  color: projectColors.whiteish,
  margin: '8px',
  backgroundColor: projectColors.darkGrey,
};

export const darkOutlinedButton = {
  color: projectColors.darkGrey,
  margin: '8px',
  borderColor: projectColors.darkGrey,
};

export const darkOutlinedTextField = {
  color: projectColors.darkGrey,
  margin: '8px',
  borderColor: projectColors.darkGrey,
};

export const headerColor = {
  backgroundColor: '#F4F9F9',
};

export const commonBannerStyle = {
  zIndex: 1,
  position: 'absolute',
  top: 'Opx',
  width: '100%',
  // height: '85px',
  height: '45px',
};

export const bannerStyle = {
  ...commonBannerStyle,
  backgroundColor: projectColors.textBlue,
};

export const transparentBannerStyle = {
  ...commonBannerStyle,
  backgroundColor: 'transparent',
};

export const baobabLogoStyle = { zIndex: 3, position: 'absolute', top: '35px' };

export const screenTitle = {
  fontSize: 38,
  fontWeight: 'bolder',
  lineHeight: '5px',
  zIndex: 3,
  position: 'absolute',
  // top: '90px',
  top: '50px',
  color: projectColors.darkGrey,
};

export const blueSelect = {
  '.MuiSelect-outlined': { color: projectColors.textBlue },
  '.MuiOutlinedInput-notchedOutline': {
    borderColor: projectColors.textBlue,
  },
};

export const blueTextField = {
  m: 1,
  width: '70%',
};

export const bigSubjectIcon = {
  width: 62,
  hight: 58,
};

export const smallSubjectIcon = {
  width: 31,
  hight: 29,
};

export const schoolGradePaper = {
  height: 51,
  width: 61,
  textAlign: 'center',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  boxShadow: 'none',
  border: `2px solid ${projectColors.textBlue}`,
  color: projectColors.darkGrey,
  fontSize: 13,
  fontWeight: 700,
  borderRadius: '16px',
};
